export default __webpack_public_path__ + "images/sell_step_1.jpg";